import { ClustersPage } from "../../K8s";

const KubernetesTab = () => <ClustersPage />;

export default KubernetesTab;
